import React from "react";
import { connect } from "react-redux";
import { logoff } from "../ducks/Auth";
import * as Ps from "perfect-scrollbar";
import { db } from "../services/firebase";
import companyRoutes from "../routes/company";
import "perfect-scrollbar/dist/css/perfect-scrollbar.min.css";
import CompanyHeader from "../components/Header/CompanyHeader";
import CompanySidebar from "../components/Sidebar/CompanySidebar";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";

class Company extends React.Component {
  componentDidMount() {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      Ps.initialize(this.refs.mainPanel, {
        wheelSpeed: 2,
        suppressScrollX: true,
      });
    }

    this.checkForDisabledAccounts();
  }

  isMac() {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
  componentDidUpdate(e) {
    this.checkForDisabledAccounts();

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      setTimeout(() => {
        Ps.update(this.refs.mainPanel);
      }, 350);
    }
    if (e.history.action === "PUSH") {
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  render() {
    return (
      <div className="wrapper">
        <CompanySidebar {...this.props} />
        <div className="main-panel" ref="mainPanel">
          <CompanyHeader {...this.props} />
          <Switch>
            {companyRoutes.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
            <Route render={() => <Redirect to="/my-company/reports/" />} />
          </Switch>
        </div>
      </div>
    );
  }

  checkForDisabledAccounts = () => {
    db.collection("users")
      .doc(this.props.user.id)
      .get()
      .then((u) => {
        if (u.exists) {
          if (!u.data().active) {
            this.props.logoff();
          }
        } else {
          this.props.logoff();
        }
      });
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default withRouter(connect(mapStateToProps, { logoff })(Company));



// WEBPACK FOOTER //
// ./src/containers/Company.jsx